import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  pushInHospitalMissionLog(inHospitalMissionLogID, missionLog) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/missionLog?inHospitalMissionLogID=${inHospitalMissionLogID}`;

    return httpPost(apiUrl, missionLog);
  }

  modifyInHospitalMissionLog(
    inHospitalMissionLogID,
    missionLog,
    identifyField = {}
  ) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/missionLog?inHospitalMissionLogID=${inHospitalMissionLogID}`;

    return httpPut(apiUrl, { missionLog, identifyField });
  }

  getInHospitalMonitor(inHospitalMonitorID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/monitor?inHospitalMonitorID=${inHospitalMonitorID}`;

    return httpGet(apiUrl);
  }

  setInHospitalMonitor(inHospitalMonitorID, dateTime, data, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/monitor?inHospitalMonitorID=${inHospitalMonitorID}&dateTime=${dateTime}&optUserID=${optUserID}`;

    return httpPost(apiUrl, data);
  }

  updateInHospital(inHospitalID, inHospital, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/?inHospitalID=${inHospitalID}&optUserID=${optUserID}`;

    return httpPost(apiUrl, inHospital);
  }

  updateInHospitalSettle(inHospitalID, settle, total, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/settle?inHospitalID=${inHospitalID}&total=${total}&optUserID=${optUserID}`;

    return httpPut(apiUrl, settle);
  }

  updateInHospitalDischarge(inHospitalID, inHospitalMissionLogID, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/discharge?inHospitalID=${inHospitalID}&inHospitalMissionLogID=${inHospitalMissionLogID}&optUserID=${optUserID}`;

    return httpPut(apiUrl);
  }

  getActiveInHospitalMissionLog() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/missionLog/active`;
    return httpGet(apiUrl);
  }

  getInHospitalQuotationPDF(inHospital) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/quotationPdf`;

    return httpPost(apiUrl, inHospital);
  }
}
